<template>
  <div class="table-container">
    <table aria-label="provider biography">
      <tbody>
        <tr>
          <td rowspan="60" width="20%">
            <img
              v-if="contact.gender === 'F'"
              src="@/assets/images/avatar-female.jpg"
              class="provider__avatar"
            />
            <img v-else src="@/assets/images/avatar-male.jpg" class="provider__avatar" />
          </td>
        </tr>
        <tr>
          <td class="provider__title capitalize">
            <span v-if="contact.relationType"
              >{{
                (
                  allData.relationDescriptions.find(
                    (rel) => rel.id == contact.relationType
                  ) || { value: "" }
                ).value
              }}</span
            >
            <!-- <span><text-highlight :queries="keywords">{{ specialty.replace(/\-/g,' ') }}</text-highlight></span> -->
          </td>
        </tr>
        <!-- <tr v-if="provider.affiliation">
        <td class="provider__info capitalize">
          <font-awesome-icon icon="building" class="icon"/>
          <b> Location:</b> {{ provider.affiliation.toLowerCase() }}
        </td>
      </tr> -->
        <tr v-if="getFullAddress() != ''">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon" />
            <span> <b> Address:</b> {{ getFullAddress() }}</span>
          </td>
        </tr>
        <tr v-if="contact.primaryPhone">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>{{
              contact.primaryPhoneType
                ? allData.phoneTypes.find((type) => type.id == contact.primaryPhoneType)
                    .type + ": "
                : "Primary: "
            }}</b
            ><a class="phone1" :href="'tel:' + contact.primaryPhone">{{
              contact.primaryPhone
            }}</a>
          </td>
        </tr>
        <tr v-if="contact.secondaryPhone">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>{{
              contact.secondaryPhoneType
                ? allData.phoneTypes.find((type) => type.id == contact.secondaryPhoneType)
                    .type + ": "
                : "Secondary: "
            }}</b
            ><a class="phone1" :href="'tel:' + contact.secondaryPhone">{{
              contact.secondaryPhone
            }}</a>
          </td>
        </tr>
        <tr v-if="contact.email">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'inbox']" class="icon" /><b> E-mail: </b
            ><a class="email" :href="'mailto:' + contact.email">{{ contact.email }}</a>
          </td>
        </tr>
        <tr v-if="contact.status && contact.status_time">
          <td class="provider__info capitalize">
            <b>Status: </b>{{ contact.status }} ({{ contact.status_time }})
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ContactBio",
  props: {
    contact: Object,
    keywords: {
      type: Array,
      default: function () {
        // no text highlight if it is a child of the Provider component, else it accepts whatever passed in
        if (this.$route.path.indexOf("contact") === 1) return [];
      },
    },
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
  methods: {
    getFullAddress() {
      // console.log(this.contact)
      let answer = "";
      let values = [this.contact.address1, this.contact.address2, this.contact.city];
      values.forEach(function (item) {
        if (item) {
          if (answer === "") answer += item;
          else answer = answer + ", " + item;
        }
      });
      if (this.contact.state) {
        let stateName = this.allData.states.find(
          (state) => state.id == this.contact.state || state.abbr == this.contact.state
        ).name;
        if (answer == "") answer += stateName;
        else answer = answer + ", " + stateName;
      }
      if (this.contact.zip) {
        if (answer == "") answer += this.contact.zip;
        else answer = answer + ", " + this.contact.zip;
      }
      return answer;
    },
  },
};
</script>

<style scoped lang="scss">
$color-font: darken(#58595b, 10%);
table {
  text-align: left;
  width: 100%;
}

tr {
  font-size: 0.95em;
}

.table-container {
  padding: 1em 2em 1.5em;
  border-bottom: 1px solid lightgray;
}

.provider__avatar {
  width: 100px;
}

.provider__title {
  font-size: 1.5em;
}

.provider__info {
  color: $color-font;
  line-height: 1.8em;
}

.icon {
  margin-right: 0.5em;
}

.capitalize {
  text-transform: capitalize;
}
</style>
